import { AttributeDataTypeName } from "@medapro-types/AttributeManager/components/GlobalAttributeTabTypes";
import { ILanguage, ILocalizedRecord } from "@medapro-types/common/components/localizedDataListEditorTypes";
import { ContentLanguagesState } from "@medapro-types/common/store/metadata";

import { ComputedRef, computed, reactive } from "vue";
import VueI18n, { TranslateResult } from "vue-i18n";
import { useStoreModule } from "@/wrappedStore";

const { useState: useMetadataState } = useStoreModule("metadata");
//@ts-ignore
const { contentLanguages } = useMetadataState(["contentLanguages"]) as { contentLanguages: ComputedRef<ContentLanguagesState> };

export const AttributeDataTypes: { key: AttributeDataTypeName; name: string }[] = [
  { key: "AttributeDataTypeAlphanumerical", name: "AttributeDataTypes.Alphanumerical" },
  { key: "AttributeDataTypeNumerical", name: "AttributeDataTypes.Numerical" },
  { key: "AttributeDataTypeLogical", name: "AttributeDataTypes.Logical" },
  { key: "AttributeDataTypeInterval", name: "AttributeDataTypes.Interval" },
  { key: "AttributeDataTypeDate", name: "AttributeDataTypes.Date" }
];

export const TranslatedDataTypes = (translate: (key: VueI18n.Path, values?: VueI18n.NamedValue) => VueI18n.TranslateResult) =>
  computed((): ILocalizedRecord<{ key: AttributeDataTypeName; name: string | TranslateResult }>[] => {
    return AttributeDataTypes.map((x: { key: AttributeDataTypeName; name: string }) => {
      return contentLanguages.value.enabled.reduce(
        (value: ILocalizedRecord<{ key: AttributeDataTypeName; name: string | TranslateResult }>, lang: ILanguage) => {
          value[lang.languageCode] = { key: x.key, name: translate(x.name) };
          return value;
        },
        reactive({})
      );
    });
  });
